import { Box } from "@mui/material";
import CarouselCard from "Components/UI/CarouselCard";
import StandardAnalyticsCard from "features/analytics/components/StandardAnalyticsCard";
import { StandardAnalyticsChartStatCard } from "features/analytics";
import {
  CHART_KEY_DASHBOARD_PROFITABILITY_CAC,
  CHART_KEY_DASHBOARD_PROFITABILITY_LTV_CAC,
  CHART_KEY_DASHBOARD_PROFITABILITY_MARGIN_TREND,
  CHART_KEY_DASHBOARD_PROFITABILITY_MER_TREND,
  CHART_KEY_DASHBOARD_PROFITABILITY_NET_REVENUE,
} from "features/analytics/constants/chartKeys";
import {
  ApiChartAttribute,
  ApiChartTemplate,
  ApiChartType,
  ApiDimension,
  ApiMetric,
} from "@incendium/api";

interface IProfitabilityTabProps {
  attributes: ApiChartAttribute[];
}

function ProfitabilityTab({ attributes }: IProfitabilityTabProps) {
  return (
    <>
      <CarouselCard
        title="Key Stats"
        emptyMessage="No key stats available"
        items={[
          <StandardAnalyticsChartStatCard
            chartKey={CHART_KEY_DASHBOARD_PROFITABILITY_LTV_CAC}
            staticAttributes={attributes}
            chart={{
              name: "LTV:CAC Ratio",
              dimension: [ApiDimension.DIMENSION_NOT_SET],
              template: ApiChartTemplate.SNAPSHOT,
              type: ApiChartType.STAT_CARD,
              includePublisherReadyOnly: true,
              attributes: [],
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_LTV_CAC_RATIO],
                },
              ],
              displayOptions: {
                statTitle: "LTV:CAC Ratio",
              },
              comparison: true,
            }}
          />,
          <StandardAnalyticsChartStatCard
            chartKey={CHART_KEY_DASHBOARD_PROFITABILITY_NET_REVENUE}
            staticAttributes={attributes}
            chart={{
              name: "Net Revenue",
              dimension: [ApiDimension.DIMENSION_NOT_SET],
              template: ApiChartTemplate.SNAPSHOT,
              type: ApiChartType.STAT_CARD,
              attributes: [],
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_SESSION_NET_REVENUE],
                },
              ],
              displayOptions: {
                statTitle: "Net Revenue",
              },
              comparison: true,
            }}
          />,
          <StandardAnalyticsChartStatCard
            chartKey={CHART_KEY_DASHBOARD_PROFITABILITY_CAC}
            staticAttributes={attributes}
            chart={{
              name: "New Customer CAC",
              dimension: [ApiDimension.DIMENSION_NOT_SET],
              template: ApiChartTemplate.SNAPSHOT,
              type: ApiChartType.STAT_CARD,
              attributes: [],
              includePublisherReadyOnly: true,
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_CAC],
                },
              ],
              displayOptions: {
                statTitle: "New Customer CAC",
              },
              comparison: true,
            }}
          />,
        ]}
        loading={false}
      />

      <Box sx={{ height: 400, flexShrink: 0 }}>
        <StandardAnalyticsCard
          chartKey={CHART_KEY_DASHBOARD_PROFITABILITY_MARGIN_TREND}
          staticAttributes={attributes}
          chart={{
            name: "Contribution Margin Trend",
            dimension: [ApiDimension.DIMENSION_SESSION_START_BY_DAY],
            template: ApiChartTemplate.TREND,
            type: ApiChartType.GRAPH,
            attributes: [],
            includePublisherReadyOnly: true,
            yAxisKeys: [
              {
                key: "l",
                fields: [ApiMetric.METRIC_SESSION_CONTRIBUTION_MARGIN],
              },
            ],
            displayOptions: {
              noFilters: true,
            },
          }}
        />
      </Box>

      <Box sx={{ height: 400, flexShrink: 0 }}>
        <StandardAnalyticsCard
          chartKey={CHART_KEY_DASHBOARD_PROFITABILITY_MER_TREND}
          staticAttributes={attributes}
          chart={{
            name: "Marketing Efficiency Ratio (MER)",
            dimension: [ApiDimension.DIMENSION_SESSION_START_BY_DAY],
            template: ApiChartTemplate.TREND,
            type: ApiChartType.GRAPH,
            attributes: [],
            includePublisherReadyOnly: true,
            yAxisKeys: [
              {
                key: "l",
                fields: [ApiMetric.METRIC_SESSION_EFFICIENCY_RATIO],
              },
            ],
            displayOptions: {
              noFilters: true,
            },
          }}
        />
      </Box>
    </>
  );
}

export default ProfitabilityTab;
